import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

import VModal from 'vue-js-modal';
import VueAnalytics from 'vue-analytics';
import App from './App.vue';
import router from './router';


const VueInputMask = require('vue-inputmask').default;

Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.component('ValidationProvider', ValidationProvider);

Vue.use(VueAnalytics, { id: 'UA-149852725-1', router });

Vue.use(VModal);
Vue.use(VueInputMask);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
